export default __webpack_public_path__ + "images/eb51a485c0ae3de4923a9b14d27d8b3f.png";